import { AbstractControl, FormControl } from '@angular/forms';
import {
  FormAdditionalAddress,
  FormAddress,
} from '@domgen/dgx-fe-forms/address';
import { WorldpayFormField } from './worldpay-form-field.enum';

export interface WorldpayForm {
  [WorldpayFormField.Address]: AbstractControl<FormAddress>;
  [WorldpayFormField.BillingAddress]: AbstractControl<FormAdditionalAddress>;
  [WorldpayFormField.PaperlessPreference]: FormControl<boolean | null>;
  [WorldpayFormField.TermsAndConditions]: FormControl<boolean | null>;
}
